import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './Day.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "td",
    {
      staticClass: "day",
      attrs: {
        highlighted: _vm.isHighlighted,
        "range-start": _vm.isRangeStart,
        "range-end": _vm.isRangeEnd
      }
    },
    [
      _c(
        "Button",
        {
          staticClass: "date",
          attrs: {
            appearance: "subtle",
            today: _vm.day.isToday,
            disabled: _vm.isDisabled,
            "is-not-same-month": _vm.day.isNotSameMonth,
            "is-selected": _vm.day.isSelected
          },
          on: {
            click: function($event) {
              $event.stopPropagation();
              return _vm.onDateSelected($event)
            }
          }
        },
        [_vm._v("\n        " + _vm._s(_vm.date) + "\n    ")]
      )
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-aa13da68";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Calendar/Day.vue.js